export const getAlignY = alignY => {
  if (alignY === 'bottom') {
    return 'end';
  }
  return alignY === 'top' ? 'start' : 'center';
};